<template>
    <div>
        <el-form ref="form" inline :model="queryForm" style="text-align: center">
            <el-form-item>
                <el-input v-model="queryForm.docNo" clearable placeholder="Receipt No."></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.customerName" clearable placeholder="Customer Name"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.vendorName" clearable placeholder="Vendor Name"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.phone" clearable placeholder="Customer Phone No."></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.receiptDate" clearable placeholder="Receipt Date"></el-input>

<!--                <el-date-picker-->
<!--                        v-model="queryForm.receiptDate"-->
<!--                        type="date" clearable-->
<!--                        placeholder="Receipt Date">-->
<!--                </el-date-picker>-->
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.invNo" clearable placeholder="Statement No."></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.orderNo" clearable placeholder="Order No."></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.description" clearable placeholder="Main Description"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.payMethod" clearable placeholder="Payment Method"></el-input>

<!--                <payment-method-filter :status.sync="queryForm.payMethod"></payment-method-filter>-->
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryForm.totalAmount" clearable placeholder="Total Amount"></el-input>
            </el-form-item>

            <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
            <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
        </el-form>

        <el-table
                @row-dblclick="download"
                fit
                v-loading="loading"
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'docNo',label:'Receipt No.'},
                        {prop:'customerName',label:'Customer Name'},
                        {prop:'vendorName',label:'Vendor Name'},
                        // {prop:'maName',label:'MA Name'},
                        {prop:'phone',label:'Customer Phone No.'},
                        {prop:'receiptDate',label:'Receipt Date'},
                        {prop:'invNo',label:'Statement No.'},
                        {prop:'orderNo',label:'Order No.'},
                        {prop:'description',label:'Main Description'},
                        {prop:'payMethod',label:'Payment Method'},
                        {prop:'totalAmount',label:'Total Amount'},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {receiptList, exportReceiptList, downloadFile} from '@/api/DocumentAPI'
    import {downloadPdf, excelRequestRequest} from "@/utils/ApiUtils";

    export default {
        name: "Receipts",
        data: function () {
            return {
                loading: false,
                queryForm: {},
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},

            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, receiptList)
            },
            exportData() {
                excelRequestRequest(this, exportReceiptList);
            },
            download(row) {
                this.loading = true
                downloadFile(row.docNo)
                    .then((res) => {
                        downloadPdf(res)
                        this.loading = false
                    })

            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
